'use client';

import { useTranslation } from 'react-i18next';

import type { MeasurementDisplayProps } from '../types';
import { conversions } from './measurement-conversions';

/**
 * Format a measurement value for display
 */
export const formatDisplayValue = (
  value: number,
  type: MeasurementDisplayProps['measurementType'],
  unit: MeasurementDisplayProps['currentUnit'],
): string => {
  if (unit === 'imperial') {
    if (type === 'height') {
      const { feet, inches } = conversions.cmToFeet(value);
      return `${feet}'${inches}"`;
    }
    if (type === 'weight') {
      return `${conversions.kgToLbs(value)} lbs`;
    }
    return `${conversions.cmToInches(value)}"`;
  }

  if (type === 'height') return `${value} cm`;
  if (type === 'weight') return `${value} kg`;
  return `${value} cm`;
};

/**
 * Display component for formatted measurement values
 * Shows the stored metric value and indicates if currently viewing in imperial
 */
export function MeasurementDisplay({
  value,
  measurementType,
  currentUnit,
}: MeasurementDisplayProps) {
  const { t } = useTranslation();

  if (!value || value <= 0) return null;

  return (
    <div className="text-muted-foreground text-xs">
      {formatDisplayValue(value, measurementType, 'metric')}
      {currentUnit === 'imperial' &&
        ` ${t('dancer:measurement.storedAsMetric')}`}
    </div>
  );
}
